import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CustomerAuthProvider } from './contexts/CustomerAuthContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Footer from './components/Footer';
import Legal from './components/Legal';
import SimCards from './components/SimCards';
import ConstructionBanner from './components/ConstructionBanner';
import AdminPanel from './components/AdminPanel';
import Store from './components/Store';
import ProductDetail from './components/ProductDetail';
import CategoryPage from './components/CategoryPage';
import SupportPage from './components/SupportPage';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Load Chatwoot globally on all pages
  useEffect(() => {
    // Load Chatwoot SDK exactly as in the provided script
    const BASE_URL = "https://chatwoot-web.caprover.distracker.com.mx";
    const script = document.createElement('script');
    script.src = BASE_URL + "/packs/js/sdk.js";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.chatwootSDK.run({
        websiteToken: 'nySuQ3wFdYbYg5drH3PgWPNU',
        baseUrl: BASE_URL
      });

      // Wait a tiny bit to ensure the widget is initialized, then set the locale
      setTimeout(() => {
        if (window.$chatwoot) {
          window.$chatwoot.setLocale('es');
        }
      }, 500);
    };

    script.onerror = () => {
      console.error('Failed to load Chatwoot script');
    };

    // Cleanup function
    return () => {
      // No cleanup needed for Chatwoot SDK
      // The SDK manages its own lifecycle
    };
  }, []);

  return (
    <CustomerAuthProvider>
      <Router>
        <div className="App">
          {/* TEMPORARY: Remove this line to hide construction banner */}
          <ConstructionBanner />
          <Navbar isScrolled={isScrolled} />
          
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Features />
                {/* <Pricing /> */}
              </>
            } />
            <Route path="/legal" element={<Legal />} />
            <Route path="/sim_cards" element={<SimCards />} />
            <Route path="/tienda" element={<Store />} />
            <Route path="/tienda/categoria/:id" element={<CategoryPage />} />
            <Route path="/tienda/producto/:id" element={<ProductDetail />} />
            <Route path="/soporte" element={<SupportPage />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          
          <Footer />
          <FloatingWhatsApp />
        </div>
      </Router>
    </CustomerAuthProvider>
  );
}

export default App; 